import React from 'react';
import './Footer.css'

export default function Footer() {
  return (
    <div className="footer">

      <div className="footer-icon-div">
        <img className="footer-logo" alt="dallas-logo" src="https://static.www.nfl.com/t_q-best/league/api/clubs/logos/DAL" /><br />
        <div className="footer-links">
        <a className="footer-links" href="https://www.linkedin.com/in/darnycya/">Linkedin</a>
        <a className="footer-links" href="https://medium.com/@darnycya"> Medium</a>
          <a className="footer-links" href="https://www.darnycya.com/">Portfolio</a>
          </div>
      </div>
      </div>
  )
}
